// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 159 ? "@atlaskit-internal_Tooltip" : chunkId) + "." + {"159":"a2929666","483":"12ed3007","684":"a85e8955","787":"ee60690f"}[chunkId] + ".chunk.js";
};